module.exports = __webpack_public_path__ + "media/images/payment-providers/sofort-card-7909df794f0ee9d69305075556c30f77.svg";